import React from 'react';
export function CookiesContent() {
  return <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-117">
      <p className="text-sm text-[#8b6f6f]" data-id="element-118">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-119">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-120">
          ¿Qué son las Cookies?
        </h2>
        <p data-id="element-121">
          Las cookies son pequeños archivos de texto que se almacenan en su
          dispositivo cuando visita un sitio web.
        </p>
      </section>

      <section data-id="element-122">
        <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-123">
          Tipos de Cookies
        </h2>
        <p data-id="element-124">
          Utilizamos cookies esenciales, de rendimiento y de marketing para
          mejorar su experiencia.
        </p>
      </section>
    </div>;
}